import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import { GroundCommonContent } from "../../../../modules/content/components/GroundCommonContent/GroundCommonContent";
import { GroundMedia } from "../../../../modules/content/components/GroundMedia/GroundMedia";
import { GroundRichText } from "../../../../modules/content/components/GroundRichText/GroundRichText";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { IFeaturedTestimonialBlockProps } from "./FeaturedTestimonialBlock.props";

export const FeaturedTestimonialBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  testimonial,
}: IFeaturedTestimonialBlockProps) => {
  if (!eyebrow && !heading && !description && !testimonial?.quote) return null;
  const Link = getComponent("Link");

  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <GroundCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {testimonial ? (
          <figure className="grid bg-primary text-primary-foreground md:grid-cols-[minmax(18rem,0.8fr)_1.2fr]">
            {testimonial.portrait ? (
              <GroundMedia
                aspectRatio="1:1"
                className="h-full"
                media={testimonial.portrait.image}
                sizes="(min-width: 768px) 35vw, 100vw"
              />
            ) : null}
            <div
              className={cn(
                "flex flex-col justify-center p-7 md:p-12 lg:p-16",
                !testimonial.portrait && "md:col-span-full",
              )}
            >
              <blockquote>
                <GroundRichText
                  className="font-ground-body text-3xl leading-tight text-primary-foreground md:text-4xl"
                  content={testimonial.quote}
                />
              </blockquote>
              <figcaption className="mt-8">
                <p className="font-ground-mono text-sm font-medium">{testimonial.name}</p>
                {testimonial.attribution ? (
                  <p className="mt-2 font-ground-mono text-xs text-primary-foreground/75">
                    {testimonial.attribution}
                  </p>
                ) : null}
              </figcaption>
              {testimonial.link ? (
                <Link
                  aria-label={testimonial.link.accessibilityLabel || undefined}
                  className="mt-6 inline-flex min-h-11 items-center self-start font-ground-mono text-xs text-primary-foreground underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-oxidized-orange"
                  href={testimonial.link.href}
                  rel={testimonial.link.openInNewTab ? "noopener noreferrer" : undefined}
                  target={testimonial.link.openInNewTab ? "_blank" : undefined}
                >
                  {testimonial.link.label}
                </Link>
              ) : null}
            </div>
          </figure>
        ) : null}
      </div>
    </GroundSection>
  );
};

FeaturedTestimonialBlock.displayName = "Block::FeaturedTestimonialBlock";
